<template>
  <div class="list row">
    <h2>LTR AO+AN - Kalkulacija</h2>
    <div class="actions d-flex flex-row-reverse">
      <button type="button" class="btn btn-primary bi bi-arrow-clockwise" @click="refreshData" />
      <button type="button" class="btn btn-success bi bi-plus" @click="addData" />
    </div>
    <data-table url="ao-an" :columns="columns" :templates="templates" :headings="headers" :actions="actions"
      ref="datatable" @yes="deleteData" name="AoAn">
    </data-table>
  </div>
</template>

<script>
import AoAnDataService from "../../services/ao-an.service";
import DataTable from "../widgets/DataTable.vue";
import AoAnForm from "./AoAnForm.vue";

export default {
  name: "ao-an",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: [
        "valid_from",
        "active",
        "edit",
      ],
      headers: {
        valid_from: "Važi od",
        active: "Aktivno",
        edit: "",
      },
      templates: {
        active: function (h, row) {
          return row.active == 1 ? 'Aktivno' : 'Neaktivno';
        }
      },
      actions: {
        edit: { commp: AoAnForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: AoAnForm,
        params: { data: {}, title: "Dodaj novi AO+AN" },
      });
    },
    deleteData(data) {
      // Delete all three types for this valid_from
      AoAnDataService.deleteByValidFrom(data.valid_from)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e.response?.data?.message || e.message || "Error deleting AO+AN",
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  /* max-width: 750px; */
  margin: auto;
}
</style>
